import { useState } from "react";

export type SnackbarSeverity = "success" | "error";

interface ISnackbarOptions {
  message: string;
  severity: SnackbarSeverity;
}

export const useSnackbar = () => {
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarOptions, setSnackbarOptions] = useState<ISnackbarOptions>({
    message: "",
    severity: "success",
  });

  const showSnackbar = (
    message: string,
    severity: SnackbarSeverity = "success"
  ) => {
    setSnackbarOptions({ message, severity });
    setSnackbarOpen(true);
  };

  const hideSnackbar = () => {
    setSnackbarOpen(false);
  };

  const getSnackbarProps = () => ({
    open: snackbarOpen,
    message: snackbarOptions.message,
    severity: snackbarOptions.severity,
    onClose: hideSnackbar,
  });

  return {
    showSnackbar,
    hideSnackbar,
    getSnackbarProps,
  };
};
